import React from "react";
import Layout from "../Layout";
import SupervisorWorkSchedule from "../../../widgets/management/supervisor-work-schedule/WorkSchedule";

function WorkSchedule() {
  return (
    <Layout>
      <SupervisorWorkSchedule />
    </Layout>
  );
}

export default WorkSchedule;

